export default {
  sections: {
    order_summary: 'Récapitulatif de commande',
  },
  labels: {
    add_items: 'Ajoutez des articles pour commencer',
    item_count_one: '{{count}} article',
    item_count_other: '{{count}} articles',
  },
  buttons: {
    return: 'Retour',
  },
  tip: 'Pourboire',
};
